import { render, staticRenderFns } from "./Tooltip.vue?vue&type=template&id=588ded98&scoped=true&"
import script from "./Tooltip.vue?vue&type=script&lang=js&"
export * from "./Tooltip.vue?vue&type=script&lang=js&"
import style0 from "./Tooltip.vue?vue&type=style&index=0&id=588ded98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588ded98",
  null
  
)

export default component.exports